<template>
  <el-form ref="creative" :model="{}" label-width="146px" :rules="rules">
    <el-form-item label="计划位置">
      <RadioGroup :value="creativeForm.scene" type="button" v-if="creativeForm.union">
        <Radio :label="5">快手计划联盟</Radio>
      </RadioGroup>
      <RadioGroup v-model="creativeForm.scene" type="button" v-else @on-change="changScene">
        <Radio v-for="s in KuaiShou.CREATIVE_SCENE_LIST" :key="s.value" :label="s.value">{{ s.label }}</Radio>
      </RadioGroup>
    </el-form-item>
    <el-form-item label="" v-if="creativeForm.scene === KuaiShou.CREATIVE_SCENE.POSTIONS" prop="scene_id">
      <CheckboxGroup v-model="creativeForm.scene_id">
        <Checkbox :label="scene.value" v-for="scene in KuaiShou.CREATIVE_SCENE_POSITIONS_LIST" :key="scene.value">
          {{ scene.label }}
        </Checkbox>
      </CheckboxGroup>
    </el-form-item>
    <el-form-item label="创意形式">
      <RadioGroup v-model="creativeForm.unit_type" type="button" @on-change="initCreatives">
        <Radio :label="KuaiShou.CREATIVE_UNIT_TYPE.CUSTOM">自定义</Radio>
        <Radio :label="KuaiShou.CREATIVE_UNIT_TYPE.ASSEMBLE" :disabled="!!creativeForm.outer_loop_native">程序化</Radio>
      </RadioGroup>
    </el-form-item>

    <template v-if="enableNativeAd">
      <el-form-item label="原生计划投放">
        <div class="native-switch">
          <el-switch v-model="creativeForm.outer_loop_native" :active-value="1" :inactive-value="0"></el-switch>
          <span style="font-size: 12px">&ensp;开启后，能使用原生投放样式，突破流量限制，额外获得优质原生流量。</span>
        </div>
      </el-form-item>

      <template v-if="creativeForm.outer_loop_native">
        <el-form-item label="授权类型">
          <el-radio-group v-model="creativeForm.kol_user_type" @change="getNativeInfo">
            <el-radio-button :label="2">服务号授权</el-radio-button>
            <el-radio-button :label="1">个人号授权</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="头像与昵称" prop="nativeId">
          <div class="native-avatar">
            <el-select v-model="creativeForm.nativeId">
              <el-option
                v-for="item in nativeUserList"
                :key="item.user_id"
                :label="item.user_name.concat('ID：' + item.user_id)"
                :value="item.user_id"
              >
                <div class="el-option-slot">
                  <span>
                    <el-avatar size="small" :src="item.head_url"></el-avatar>
                  </span>
                  <span style="margin-left: 5px">{{ item.user_name }}</span>
                  <span style="margin-left: 5px">ID：{{ item.user_id }}</span>
                </div>
              </el-option>
            </el-select>
          </div>
        </el-form-item>
      </template>
    </template>

    <creatives
      ref="creatives"
      v-if="creativeForm.unit_type === KuaiShou.CREATIVE_UNIT_TYPE.CUSTOM"
      :data="creativeForm.creatives"
      :source="creativeForm.creativeDetails"
      :words="wordData"
      :game-data="gameData"
      :game-group-data="gameGroupData"
      :operator-data="operatorData"
      :label-data="labelData"
      :max="15"
      :verify="verify"
      :scene-id="creativeForm.scene"
      :open-id="opId"
      :game-id="gameId"
      :media="mediaId"
      @on-splice="spliceCreative"
    />
    <smarts
      ref="creatives"
      v-else
      v-model="creativeForm.smart_cover"
      :data="creativeForm.creatives"
      :source="creativeForm.creativeDetails"
      :words="wordData"
      :game-data="gameData"
      :game-group-data="gameGroupData"
      :operator-data="operatorData"
      :label-data="labelData"
      :verify="verify"
      :scene-id="creativeForm.scene"
      :open-id="opId"
      :game-id="gameId"
      :media="media"
      @on-add="pushCreative"
      @on-replace="replaceCreative"
      @on-delete="delCreative"
      @on-sticker="selectSticker"
    />

    <el-form-item label="素材挖掘" v-show="creativeForm.unit_type === KuaiShou.CREATIVE_UNIT_TYPE.ASSEMBLE">
      <i-Switch v-model="creativeForm.asset_mining" />
    </el-form-item>
    <!-- <el-form-item label="自动发送礼包码">
      <i-Switch v-model="creativeForm.gift" @on-change="changeGift" />
    </el-form-item>
    <el-form-item label="发送时机" v-if="isAndroid && creativeForm.gift">
      <RadioGroup type="button" v-model="creativeForm.target_action_type">
        <Radio :label="30">开始下载后</Radio>
        <Radio :label="31">下载完成后</Radio>
        <Radio :label="32">安装完成后</Radio>
      </RadioGroup>
    </el-form-item>
    <el-form-item label="礼包码" v-if="creativeForm.gift" prop="code">
      <input-len v-model="creativeForm.code" placeholder="最大20个字符，1个中文等于2个字符" :max="20" style="width: 480px" />
    </el-form-item> -->
    <el-form-item label="创意分类" v-if="categroyData.length">
      <category :title="['创意分类']" :value="creativeForm.mult_categroy" :data="categroyData" @on-select="selectCategroy" />
    </el-form-item>
    <el-form-item label="创意标签" prop="creative_tag">
      <add-tags v-model="creativeForm.creative_tag" :open-id="opId" @on-close="closeTag" />
    </el-form-item>
    <el-form-item label="点击监测链接">
      <Input readonly placeholder="内部计划自动生成" disabled />
    </el-form-item>
  </el-form>
</template>
<script>
import { isArray, deepCopy, getIdOfData } from '@/common/js/utils'
import { getCreativeWords, getCreativeCategory, getCreativeStyles } from '@/api/kuaishou.model'
import { adGames, getSysTag, getCaoHuaOpenIds } from '@/api/common.model'
import { getPtomGroupGames } from '@/api/material.model'
import { getKuaiShouNativeUserList } from '@/api/kuaishou.local.model'
import { makeCreativeRules } from './data/form-rules.js'

import Category from '@/views/create/kuaishou_local/components/idea/selecter/category.vue'
import AddTags from '@/views/create/kuaishou_local/components/idea/selecter/add-tags.vue'
import KuaiShou from './data/index.class'
import Creatives from './components/idea/creative/creative.vue'
import Smarts from './components/idea/creative/smart.vue'

const decompile = (id, data) => {
  const arr = []
  const level3 = getIdOfData(data, id)
  const level2 = getIdOfData(data, level3.parent)
  const level1 = getIdOfData(data, level2.parent)
  arr.push(...[level3, level2, level1])
  return arr
}
export default {
  components: { Creatives, Smarts, Category, AddTags },
  props: {},
  computed: {
    editState() {
      return this.$route.path.includes('/edit/')
    },
    KuaiShou() {
      return KuaiShou
    },
    isAndroid() {
      return this.innerForm.ch_platform_id === KuaiShou.GAME_PLATFORM.ANDROID
    },
    taskInfo() {
      return this.$store.state.Kuaishou.taskInfo
    },
    formData() {
      return this.$store.getters['Kuaishou/currTaskParams']
    },
    innerForm() {
      return this.formData.innerForm
    },
    outterForm() {
      return this.formData.outterForm
    },
    creativeForm: {
      get() {
        return this.formData.creativeForm
      },
      set(v) {
        this.$store.commit('Kuaishou/UPDATE_CREATIVE_PARAMS', v)
      }
    },
    accounts() {
      return [
        {
          id: this.formData.ad_account_id,
          name: this.formData.ad_account_name
        }
      ]
    },
    mediaId() {
      return KuaiShou.MEDIA_ID
    },
    opId() {
      return this.formData.ad_account_id
    },
    gameId() {
      return this.innerForm.game_id
    },
    enableNativeAd() {
      const { union } = this.outterForm
      const { unit_type, scene_id } = this.creativeForm

      if (union) return false // 广告联盟不显示
      if (scene_id.length === 1 && scene_id[0] === 10) return false // 只选快手联盟优选广告不显示
      // return unit_type === KuaiShou.CREATIVE_UNIT_TYPE.CUSTOM // 自定义创意才显示
      return true
    }
  },
  watch: {
    // 当前批量复制切换账号时
    'formData.ad_account_name'() {
      // 重新根据账号id获取页面数据
      this.getCreativeData()
    },

    // 当前批量复制切换任务时，对创意标签进行解析
    'taskInfo.currTaskId'() {
      const creativeForm = Object.assign({}, this.creativeForm)
      creativeForm.mult_categroy = decompile(this.creativeForm.creative_category, this.categroyData)
      this.creativeForm = creativeForm

      // 切换任务时。要重新获取页面数据；已知问题：切换到程序化时，贴纸不会显示
      this.getCreativeData()
    }
  },
  data() {
    return {
      rules: { ...makeCreativeRules.call(this) },
      media: Number(this.$store.state.Kuaishoulocal.media),
      wordData: [],
      categroyData: [],
      styleData: [],
      operatorData: [],
      gameData: [],
      gameGroupData: [],
      labelData: [],
      nativeUserList: [], // 原生广告头像与昵称列表数据
      verify: false
    }
  },
  methods: {
    /**
     * @description: 根据账号id获取当前授权类型支持情况，目前普通快手号需要白名单支持
     * @param {*} kol_user_type 1 普通快手号 2 服务号
     */
    getNativeInfo() {
      const [account] = this.accounts
      const adAccountId = account?.id

      getKuaiShouNativeUserList({ kol_user_type: this.creativeForm.kol_user_type, adAccountId })
        .then((data) => {
          this.nativeUserList = data?.user_list || []

          const nativeIds = this.nativeUserList.map((item) => item.user_id)

          if (!nativeIds.includes(this.creativeForm.nativeId)) {
            this.clearNativeId()
          }
        })
        .catch(() => {
          this.clearNativeId()
        })
    },

    /**
     * @description: 清空原生广告id
     */
    clearNativeId() {
      this.creativeForm = Object.assign({}, this.creativeForm, {
        nativeId: ''
      })
    },
    /**
     * @description: 切换时，清空按场景选择的广告位
     * @param {*} val
     */
    changScene(val) {
      const creativeForm = Object.assign({}, this.creativeForm)
      creativeForm.scene_id = val === KuaiShou.CREATIVE_SCENE.OPTIMIZE ? [1] : []
      this.creativeForm = creativeForm
    },
    changeGift(val) {
      const creativeForm = Object.assign({}, this.creativeForm)
      if (val) {
        creativeForm.target_action_type = this.isAndroid ? 30 : 2
        creativeForm.code = ''
      }
      this.creativeForm = creativeForm
    },
    closeTag(name) {
      const creativeForm = Object.assign({}, this.creativeForm)
      const index = creativeForm.creative_tag.findIndex((ret) => ret === name)
      if (index > -1) creativeForm.creative_tag.splice(index, 1)
      this.creativeForm = creativeForm
    },
    // 切换自定义
    initCreatives(val) {
      const creativeForm = Object.assign({}, this.creativeForm)
      const material = []

      creativeForm.creatives = []
      if (val === 7) {
        const { smart } = deepCopy(creativeForm.creativeElements)
        smart && material.push(smart)
      }
      creativeForm.creatives = material
      this.creativeForm = creativeForm
    },
    selectCategroy(item) {
      const creativeForm = Object.assign({}, this.creativeForm)
      creativeForm.mult_categroy = item
      this.creativeForm = creativeForm
    },
    // 添加自定义创意
    spliceCreative(param) {
      const creativeForm = Object.assign({}, this.creativeForm)
      let { id, type, mode, data } = param
      if (mode === 1) mode = 'vertical'
      else if (mode === 2) mode = 'video'
      else if (mode === 3) mode = 'image'
      if (type === 'add') {
        const material = creativeForm.creativeElements[mode]
        const item = deepCopy(creativeForm.creatives).pop()
        const df_id = item ? item.id : 0
        data.forEach((ret, id) => {
          const mater = deepCopy(material)
          const sourceVideo = {
            photo_id: ret.id,
            url: ret.url,
            width: ret.width,
            height: ret.height,
            file_size: ret.size,
            type: 'video'
          }
          const sourceImage = {
            image_token: ret.id,
            url: ret.cover_url,
            cover_width: ret.cover_width,
            cover_height: ret.cover_height,
            cover_size: ret.cover_size,
            type: 'video'
          }
          mater.id = df_id + id + 1
          mater.template[0].video = ret.id
          mater.template[1].cover = ret.id
          creativeForm.creativeDetails.push(...[sourceVideo, sourceImage])
          creativeForm.creatives.push(mater)
        })
      } else if (type === 'del') {
        const index = creativeForm.creatives.findIndex((ret) => ret.id === id)
        creativeForm.creatives.splice(index, 1)
      }
      this.creativeForm = creativeForm
      this.verify = false
    },
    selectSticker([idx, index]) {
      const creativeForm = Object.assign({}, this.creativeForm)
      const { template } = creativeForm.creatives[0]
      const { max_length } = template[idx].restriction
      const item = template[idx].children[index]
      const len = template[idx].children.filter((ret) => ret.check).length
      const childLen = template[3].children.length
      if (!childLen) {
        // 增加封面广告语
        const { origin_template } = template[3].restriction
        this.pushCreative({ item: deepCopy(origin_template), index: 3 })
      }
      if (item.check && len === 1) this.$set(template[3], 'children', []) // 清除封面广告语
      if ((!item.check && len < max_length) || item.check) this.$set(item, 'check', !item.check)

      this.creativeForm = creativeForm
    },
    delCreative([idx, index]) {
      const creativeForm = Object.assign({}, this.creativeForm)
      const { template } = creativeForm.creatives[0]
      template[idx].children.splice(index, 1)
      this.creativeForm = creativeForm
    },
    pushCreative({ item, index }) {
      const creativeForm = Object.assign({}, this.creativeForm)
      const { template } = creativeForm.creatives[0]
      template[index].children.push(deepCopy(item))
      this.creativeForm = creativeForm
    },
    replaceCreative({ item, index, idx }) {
      const creativeForm = Object.assign({}, this.creativeForm)
      const { template } = creativeForm.creatives[0]
      template[index].children.splice(idx, 1, deepCopy(item))
      this.creativeForm = creativeForm
    },

    /**
     * @description: 表单校验
     * @return {*} 成功promise.resolve 失败promise.reject
     */
    async formValidate() {
      this.verify = true
      await this.$nextTick()

      const creativesRef = this.$refs.creatives
      const creativesDom = creativesRef.$el
      const invalidMsg = creativesDom.querySelector('.c-col-msg')
      if (invalidMsg) {
        this.verify = false
        return Promise.reject(new Error('creative'))
      }
      this.verify = false

      return new Promise((resolve, reject) => {
        this.$refs.creative.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('creative'))
          }
        })
      })
    },

    getCreativeData() {
      const [account] = this.accounts
      const ad_account_id = account?.id
      const param = { ad_account_id }
      const requestList = [getCreativeWords(param), getCreativeCategory(param), getCreativeStyles(param)]
      Promise.all(requestList).then((data) => {
        const [words, categories, styles] = data
        if (isArray(words) && this.scene !== 5) {
          this.wordData = words
            .filter((ret) => ['日期', '星期', '节日', '年龄范围', '地区'].includes(ret.name))
            .map((ret) => {
              ret.max_word_length += ret.max_word_length
              return ret
            })
        }

        if (isArray(categories)) {
          this.categroyData = categories
          const creativeForm = Object.assign({}, this.creativeForm)
          creativeForm.mult_categroy = decompile(this.creativeForm.creative_category, categories)
          this.creativeForm = creativeForm
        }

        if (isArray(styles)) {
          this.styleData = styles
          const creativeForm = Object.assign({}, this.creativeForm)
          creativeForm.creativeElements.smart.template[2].children = deepCopy(this.styleData)
          this.creativeForm = creativeForm
        }
      })

      // 重新获取原生广告昵称与头像
      this.getNativeInfo()
    },
    preLoadData() {
      // 加载数据源

      const requestList = [getCaoHuaOpenIds(), adGames({ type: 1 }), getPtomGroupGames(), getSysTag()]

      this.getCreativeData()
      Promise.all(requestList).then((data) => {
        const [operatorData, gameData, gameGroupData, labels] = data

        if (isArray(operatorData)) this.operatorData = operatorData
        if (isArray(gameData)) this.gameData = gameData
        if (isArray(gameGroupData)) {
          this.gameGroupData = gameGroupData.map((ret) => {
            return {
              id: ret.groupId,
              name: ret.groupName,
              children: ret.gameIds
            }
          })
        }
        if (isArray(labels)) {
          this.labelData = labels.map((ret) => {
            return {
              id: ret.labelId,
              name: ret.content
            }
          })
        }
      })
    }
  },
  created() {
    this.preLoadData()
  }
}
</script>
<style lang="scss">
.el-option-slot {
  display: flex;
  align-items: center;
  > span {
    line-height: 1;
  }
}
</style>
